import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
  ApproachSelect,
  IssueSelect,
  OrganizationTypeSelect,
} from "../../../components";
import { useInternationalization } from "../../i18n";
import useQuery from "../hooks/useQuery";

const FormSystem = () => {
  const { config } = useQuery()
  const {
    selectedApproaches,
    selectedIssues,
    selectedOrganizationTypes,
  } = useSelector(state => state.search);
  const [isVisible, setIsVisible] = useState(false)
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation()
  const { status } = useSelector(state => state.system)
  const { translate } = useInternationalization()

  const queryStringFromStore = useSelector(state => state.search.queryString)

  // [hack] Rerender selecboxes
  useEffect(() => {
    if(status === 'succeeded'){
      setIsVisible(false)

      setTimeout(() => {
        setIsVisible(true)
      }, 100)
    }
  }, [queryStringFromStore, status]);

  const handleEvent = (e) => {
    const { name, value } = e.target;
    const newParams = new URLSearchParams(window.location.search);

    if (config[name]) {
      newParams.delete(config[name].param);

      if (value && value.length > 0) {
        dispatch(config[name].setter(value));

        for (let index = 0; index < value.length; index++) {
          const element = value[index];
          newParams.append(config[name].param, String(element.value));
        }
      } else {
        dispatch(config[name].setter([]));
      }
    }

    history.push(location.pathname + "?" + newParams.toString());
  };

  return (
    <div className="mb-8">
      <p className="font-bold text-sm mb-4">
        {translate('SEARCH', 'type')}
      </p>
      {
        isVisible &&
        <>
          <div className="mb-3">
            <OrganizationTypeSelect
              defaultValues={selectedOrganizationTypes}
              updateForm={handleEvent}
              label={<></>}
              placeholder={translate('ORGANIZATION', 'singular')}
            />
          </div>
          <div className="mb-3">
            <ApproachSelect
              defaultValues={selectedApproaches}
              updateForm={handleEvent}
              label={<></>}
              placeholder={translate('APPROACH', 'singular')}
            />
          </div>
          <div className="mb-3">
            <IssueSelect
              defaultValues={selectedIssues}
              updateForm={handleEvent}
              label={<></>}
              placeholder={translate('ISSUE', 'singular')}
            />
          </div>
        </>
      }
    </div>
  );
};

export { FormSystem };
